import { UserApiClient } from "@foundation/intercom-client";

const userApiClient = UserApiClient.init({
  host: `${process.env.NEXT_PUBLIC_REGISTRATION_URL}/user-api`,
});

export { userApiClient };
